export class CertificadoFileObject {
   emisorId: string;
   file: File;
   password: string;
   RutFormateado: string;
   sucursalId: string;
   today: any;
   diasRestantes: any;
   EmisorRut:number;
}
